export const DOMAIN_NAME = 'propileya';

export const GET_HOUSING_LIST_API_ENDPOINT = `/search/${DOMAIN_NAME}`;
export const GET_HOUSING_OBJECT_API_ENDPOINT = `/details/${DOMAIN_NAME}`;
export const ADJACENT_LOCATIONS_API_PATH = '/adjacent-locations';
export const CREATE_INQUIRY_API_ENDPOINT = `/inquiry/send/${DOMAIN_NAME}`;
export const CREATE_OFFICE_INQUIRY_API_ENDPOINT = `/inquiry/office/${DOMAIN_NAME}`;
export const SEND_REPORT_ABOUT_PROPERTY = '/complaint/send';
export const GET_BROKER_OFFICE_DETAILS = `/office/details/${DOMAIN_NAME}`;
export const GET_BROKER_OFFICE_LIST = `/office/search/${DOMAIN_NAME}`;
export const GET_BROKER_HOUSING_LIST_API_ENDPOINT = '/search';
export const GET_POPULAR_HOUSING_API_ENDPOINT = `/immo/popular/${DOMAIN_NAME}`;
export const GET_NEWEST_PROJECTS_API_ENDPOINT = `/immo/newest-projects/${DOMAIN_NAME}`;
export const GET_SIMILAR_HOUSING_API_ENDPOINT = `/search/similar/${DOMAIN_NAME}`;
export const GET_REFERENCE_LOCATIONS_API_ENDPOINT = '/reference/location';
export const POST_RESOLVE_LOCATIONS_API_ENDPOINT = '/reference/resolve';
export const GET_PREDEFINED_SEARCH_FILTERS = '/search_filters/predefined_immo_search_profile';
export const GET_SEARCH_FILTER_STRUCTURE = '/search_filters';

export const GET_SEARCH_PROFILE = '/private/search_profile';
export const GET_WATCH_LIST = '/private/watchlist';
export const GET_USER_ME = '/private/user/me';
export const GET_MASTER_OFFICES = '/private/master/offices';
export const POST_MASTER_OFFICE_ENTER = '/private/master/office-admins';
export const POST_END_IMPERSONATION = '/private/session/end-impersonation';
export const GET_BROKER_MESSAGE = '/private/info_request';
export const GET_BROKER_LAST_MESSAGE = '/private/info_request/last';
export const GET_WHATSAPP_MESSAGE_STATUS = '/inquiry/whatsapp_message_status';
export const GET_BROKER_CONTACTS = `/details/contacts/${DOMAIN_NAME}`;

export const GET_APP_VERSION = '/app/info';

export const GET_OFFICE_PROFILE = '/private/broker_admin/office_profile';
export const POST_OFFICE_PROFILE = '/private/broker_admin/office_profile';
export const GET_OFFICE_STATISTICS = '/private/broker_admin/office_statistics';

export const GET_WLAS_CONFIG = '/private/broker_admin/wlas_config';
export const PUT_WLAS_CONFIG = '/private/broker_admin/wlas_config';
export const POST_OFFICE_SMALL_LOGO = '/private/broker_admin/office_small_logo';
export const POST_OFFICE_BIG_LOGO = '/private/broker_admin/office_big_logo';

export const FACEBOOK_URL = 'https://www.facebook.com/profile.php?id=61578956500076';
export const LINKEDIN_URL = 'https://www.linkedin.com/company/alleimmobilien/';
export const PINTEREST_URL = 'https://at.pinterest.com/alleimmobilien/';
